import React from 'react';
import { Breadcrumb, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { ExamTable } from "../../components/Tables";
// import { ProductFilter } from "../../components/Filters";



export default () => {
    return (
        <div className="justify-content-between flex-wrap flex-md-nowrap py-4">
            <div className="mb-4 mb-lg-0">
                <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
                    <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
                    <Breadcrumb.Item>Tutores</Breadcrumb.Item>
                    <Breadcrumb.Item active>Consultar</Breadcrumb.Item>

                </Breadcrumb>

                <Row className="d-flex flex-wrap flex-md-nowrap align-items-center py-4">
                    <Col className="d-block mb-4 mb-md-0">
                        <h1 className="h2">Consulta de Exames</h1>
                        <p className="mb-0">
                            Tabela contendo todos os exames cadastrados, podendo acessar pela senha fornecida.
                        </p>
                    </Col>
                </Row>
                <ExamTable/> 
            </div>
        </div >
    );
};
